module.exports = __webpack_public_path__ + "static/media/cross_icon.769e8c90.svg";